var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btnContent"},[_c('el-button',{attrs:{"size":_vm.Size,"type":_vm.Type}},[_vm._v(_vm._s(_vm.btnName))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }